"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillBuildJob = void 0;
var SkillStatus_1 = require("./SkillStatus");
/**
 * A skill build job creates definitive versions for Skill
 */
var SkillBuildJob = /** @class */ (function (_super) {
    __extends(SkillBuildJob, _super);
    function SkillBuildJob() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "SkillBuildJob";
        /**
         * The reference of this build job
         */
        _this.reference = function () {
            _this.push(function (_) { return "reference"; });
        };
        /**
         * Id of the tenant
         */
        _this.tenantId = function () {
            _this.push(function (_) { return "tenantId"; });
        };
        /**
         * reference to the skill being built
         */
        _this.skillRef = function () {
            _this.push(function (_) { return "skillRef"; });
        };
        /**
         * the associated version tag
         */
        _this.tag = function () {
            _this.push(function (_) { return "tag"; });
        };
        /**
         * The name of the build job
         */
        _this.name = function () {
            _this.push(function (_) { return "name"; });
        };
        /**
         * The current status of the build job
         */
        _this.status = function (config) { return _this.push(function (registry) {
            var entity = new SkillStatus_1.SkillStatus();
            config(entity);
            return "status { " + entity.render(registry) + " }";
        }); };
        /**
         * created at
         */
        _this.created = function () {
            _this.push(function (_) { return "created"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return SkillBuildJob;
}(Array));
exports.SkillBuildJob = SkillBuildJob;
//# sourceMappingURL=SkillBuildJob.js.map